export const painPoints = [
  {
    emoji: '🧭',
    title: 'You don’t know where to start',
    desc: 'The blank screen is your enemy. This method organizes everything: Arrests, evidence, and narratives.',
  },
  {
    emoji: '🔤',
    title: 'You struggle with legal terminology',
    desc: 'Stop guessing. Use attorney-vetted structures that sound professional and clinical.',
  },
  {
    emoji: '🧩',
    title: 'You fear the "AI red flag"',
    desc: 'Generic AI sounds fake. Our system ensures your reports sound like a 20-year veteran wrote them.',
  },
  {
    emoji: '🎯',
    title: 'You want to get home on time',
    desc: 'Spending 3 hours on paperwork after a 12-hour shift is not sustainable.',
  },
];
